export const BASE_URL = 'https://skillsewa.digital:7016'
export const FILE_SERVER_URL = 'https://skillsewa.digital:7014'
export const SOCKET_URL = 'https://skillsewa.digital:7016'
